module.exports = __webpack_public_path__ + "img/icon_t13.80c1ae2a.png";